"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var modal_1 = require("./modal");
Object.defineProperty(exports, "Modal", { enumerable: true, get: function () { return modal_1.Modal; } });
//# sourceMappingURL=index.js.map